import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { ErrorHandler, NgModule } from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconRegistry } from "@angular/material/icon";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { BrowserModule } from "@angular/platform-browser";
import {
  APPOINTMENT_SERVICE,
  CAREPLAN_EDITOR_SERVICE,
  CAREPLAN_SERVICE,
  HEALTHCARESERVICE_SERVICE,
  HELP_DATA_SERVICE,
  KNOWLEDGE_SERVICE,
  LANGUAGE_SERVICE,
  OBSERVATION_SERVICE,
  ORGANIZATION_SERVICE,
  PREFERENCE_SERVICE,
  QUESTIONNAIRE_API_SERVICE,
  QUESTIONNAIRE_SERVICE,
  RESPONSIVE_DIALOG_SERVICE,
  RESPONSIVE_SERVICE,
  RULE_SERVICE,
  SESSION_SERVICE,
  USER_SERVICE,
  USER_STAT_SERVICE,
} from "@comunicare/comunicare-angular-injection-tokens";
import { GlobalHelpDialogModule } from "@comunicare/comunicare-dashboard-modals";
import { FileLogger } from "./core/error-handling/fileLogger";
import { GlobalErrorHandler } from "./core/error-handling/global-error-handler";
import { HttpErrorInterceptor } from "./core/interceptors/http-error-interceptor";
import { HealthcareserviceService } from "./healthcareService/healthcareService.service";
import { I18nModule } from "./i18n.module";
import { KnowledgeService } from "./knowledges/knowledge.service";
import { LanguageService } from "./language/language.service";
import { OrganizationsService } from "./organization/organization.service";
import { PreferencesService } from "./preferences/preferences.service";
import { QuestionnaireApiService } from "./questionnaires/questionnaire.api";
import { QuestionnaireService } from "./questionnaires/questionnaire.service";
import { RulesService } from "./rules/rules.service";
import { ApiService } from "./shared/api/api.service";
import { AppointmentService } from "./shared/emptyServices/appointment.service";
import { CareplanEditorService } from "./shared/emptyServices/careplan-editor.service";
import { CareplanService } from "./shared/emptyServices/careplan.service";
import { ObservationsService } from "./shared/emptyServices/observations.service";
import { UserStatisticsService } from "./shared/emptyServices/user-statistics.service";
import { MatPaginatorI18N } from "./shared/mat-paginator-i18n";
import { HelpDataService } from "./shared/services/help-data.service";
import { ResponsiveDialogService } from "./shared/services/response-dialog.service";
import { ResponsiveService } from "./shared/services/responsive.service";
import { SessionService } from "./shared/services/session.service";
import { UserService } from "./user/user.service";

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    I18nModule,
    AppRoutingModule,
    HttpClientModule,
    MatSnackBarModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    GlobalHelpDialogModule,
  ],
  providers: [
    ApiService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: MatPaginatorIntl, useClass: MatPaginatorI18N },
    { provide: QUESTIONNAIRE_SERVICE, useExisting: QuestionnaireService },
    { provide: SESSION_SERVICE, useExisting: SessionService },
    { provide: USER_SERVICE, useExisting: UserService },
    { provide: LANGUAGE_SERVICE, useExisting: LanguageService },

    { provide: KNOWLEDGE_SERVICE, useExisting: KnowledgeService },
    { provide: CAREPLAN_SERVICE, useExisting: CareplanService },
    { provide: OBSERVATION_SERVICE, useExisting: ObservationsService },
    { provide: PREFERENCE_SERVICE, useExisting: PreferencesService },
    { provide: QUESTIONNAIRE_API_SERVICE, useExisting: QuestionnaireApiService },
    { provide: HEALTHCARESERVICE_SERVICE, useExisting: HealthcareserviceService },
    { provide: RULE_SERVICE, useExisting: RulesService },

    { provide: ORGANIZATION_SERVICE, useExisting: OrganizationsService },
    { provide: CAREPLAN_EDITOR_SERVICE, useExisting: CareplanEditorService },
    { provide: RESPONSIVE_DIALOG_SERVICE, useExisting: ResponsiveDialogService },
    { provide: RESPONSIVE_SERVICE, useExisting: ResponsiveService },
    { provide: HELP_DATA_SERVICE, useExisting: HelpDataService },
    { provide: USER_STAT_SERVICE, useExisting: UserStatisticsService },
    { provide: APPOINTMENT_SERVICE, useExisting: AppointmentService },

    FileLogger,
    MatIconRegistry,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
